var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5625 41.6875L44.5625 4.3125C44.5625 2.73125 43.2688 1.4375 41.6875 1.4375L4.3125 1.4375C2.73125 1.4375 1.4375 2.73125 1.4375 4.3125L1.4375 41.6875C1.4375 43.2687 2.73125 44.5625 4.3125 44.5625L41.6875 44.5625C43.2687 44.5625 44.5625 43.2687 44.5625 41.6875Z",
    fill: "#427687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5625 39.4234L44.5625 4.13281C44.5625 2.65938 43.3406 1.4375 41.8672 1.4375L6.68438 1.4375C5.175 1.4375 3.98906 2.65937 3.98906 4.13281L3.98906 39.3875C3.98906 40.8969 5.21094 42.0828 6.68437 42.0828L41.8672 42.0828C43.3406 42.1547 44.5625 40.8969 44.5625 39.4234Z",
    fill: "#8CAFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.966 13.2972L37.591 21.9222C38.2379 22.4972 38.2379 23.5034 37.591 24.0784L28.966 32.7034C28.0316 33.53 26.5941 32.8472 26.5941 31.6253L26.5941 26.5941C26.5941 26.1987 26.2707 25.8753 25.8754 25.8753L9.34414 25.8753C8.55352 25.8753 7.90664 25.2284 7.90664 24.4378L7.90664 21.5628C7.90664 20.7722 8.55352 20.1253 9.34414 20.1253L25.8754 20.1253C26.2707 20.1253 26.5941 19.8019 26.5941 19.4066L26.5941 14.3753C26.5941 13.1534 28.0316 12.4706 28.966 13.2972Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.3645 14.2674C42.1911 14.2674 42.4426 13.6924 42.3348 10.3861C42.227 7.61895 41.9036 6.25332 40.8973 5.42676C39.8911 4.6002 37.8426 4.38457 35.3989 4.34863C33.6739 4.34863 32.0567 4.34863 32.0567 5.24707C32.0567 6.46894 34.8958 6.46894 36.477 7.47519C39.6036 9.41582 40.2864 14.2674 41.3645 14.2674Z",
    fill: "#B4E1ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a15e7253246da4a69acbaf544a2b5c83.svg";
export { ForwardRef as ReactComponent };